import { Negotiation } from '@interfaces/models/negotiation';
import Environment from '@config/index';

export const getNegotiationIdFromUrl = (link: string): Negotiation['id'] => {
  if (!link) {
    return null;
  }
  const { searchParams } = new URL(link);
  return searchParams.get('negotiation_id');
};

export const getOrigin = (): string =>
  typeof window !== 'undefined' ? window.location.origin : `${Environment.baseHost}`;
